export default __webpack_public_path__ + "static/media/categorie_icons_Cancellation.506a3dd3.svg";